import { render, staticRenderFns } from "./DialogGameFormat.vue?vue&type=template&id=1fd050fc&scoped=true&lang=pug"
import script from "./DialogGameFormat.vue?vue&type=script&lang=js"
export * from "./DialogGameFormat.vue?vue&type=script&lang=js"
import style0 from "./DialogGameFormat.vue?vue&type=style&index=0&id=1fd050fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd050fc",
  null
  
)

export default component.exports